import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  activeIndex: PropTypes.number.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

const ProgressBar = ({ activeIndex, questions }) => {
  const rootClass = 'questions-progressbar';

  return (
    <div className={rootClass}>
      <ol>
        {questions.map((q, index) => {
          const qClass = classNames(`${rootClass}__item`, {
            [`${rootClass}__item--completed`]: (activeIndex > index),
            [`${rootClass}__item--active`]: (activeIndex === index),
          });
          const width = 100 / questions.length;

          return (
            <li
              className={qClass}
              key={q.id}
              style={{ width: `${width}%` }}
              title={q.text}
            />
          );
        })}
      </ol>
    </div>
  );
};

ProgressBar.propTypes = propTypes;

export default ProgressBar;
